import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function UncheckedIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 20 20" htmlColor="transparent" {...props}>
      <rect width="19" height="19" x=".5" y=".5" fill={Color.White} rx="4.5" />
      <rect width="19" height="19" x=".5" y=".5" stroke={Color.LightGray} rx="4.5" />
    </MuiSvgIcon>
  );
}
export default UncheckedIcon;
